import styled from 'styled-components'

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;

    svg {
      height: 25px;
      width: 25px;
    }
  }
`

export const Th = styled.th`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.onPrimary};
  padding: 10px;
  text-align: left;
  border: 1px solid ${({ theme }) => theme.colors.border};
`

export const Td = styled.td`
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.colors.border};
`

export const Tr = styled.tr`
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.tableRowAlt};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.tableRowHover};
  }
`

export const TableContainer = styled.div`
  overflow-x: auto;
  max-width: 100%;
`

export const AddButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  margin-top: 0;

  svg {
    height: 30px;
    width: 30px;
  }
`

export const ButtonDiv = styled.div`
  display: flex;
  justify-content: center;

  button {
    background-color: ${({ $isFormValid, theme }) => ($isFormValid ? theme.colors.primary : theme.colors.surfaceMuted)};
    color: ${({ $isFormValid, theme }) => ($isFormValid ? theme.colors.onPrimary : theme.colors.muted)};
    padding: 10px 20px;
    width: 90%;
    font-size: 16px;
    border: none;
    border-radius: 8px;
    margin-bottom: 20px;
    margin-top: 30px;
    cursor: ${({ $isFormValid }) => ($isFormValid ? 'pointer' : 'not-allowed')};
    transition:
      background-color 0.3s ease-in-out,
      transform 0.2s;

    &:hover {
      background-color: ${({ $isFormValid, theme }) =>
        $isFormValid ? theme.colors.primaryHover : theme.colors.surfaceMuted};
      transform: ${({ $isFormValid }) => ($isFormValid ? 'scale(1.05)' : 'none')};
    }

    &:active {
      background-color: ${({ $isFormValid, theme }) =>
        $isFormValid ? theme.colors.primaryActive : theme.colors.surfaceMuted};
      transform: ${({ $isFormValid }) => ($isFormValid ? 'scale(0.98)' : 'none')};
    }
  }
`

export const Select = styled.select`
  width: 100%;
  box-sizing: border-box;
  flex: 1;
  padding: 12px;
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  border-radius: 5px;
  background: ${({ theme }) => theme.colors.inputBackground};
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textPrimary};
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }
`

export const Container = styled.div`
  height: auto;
  min-height: calc(100vh - 52px);
  display: flex;
  padding: 20px;
  flex-direction: column;

  @media (max-width: 720px) {
    height: 100%;
  }

  > div:not(:first-child) {
    margin-top: 20px;
  }
`

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.colors.cardShadow};
  padding: 20px;
  margin: 0 auto;
  border: 1px solid ${({ theme }) => theme.colors.border};
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 1120px;
  width: 100%;

  h2 {
    margin: 20px 0px;
  }

  form {
    display: flex;
    flex-direction: column;
  }
`

export const InputDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 100%;
  margin-bottom: 10px;

  input[type='checkbox'] {
    width: 20px;
    height: 20px;
    display: inline-block;
    margin: 0;
    text-align: left;
  }

  @media (max-width: 720px) {
    flex-direction: column;
    align-items: start;
  }

  div {
    display: flex;
    flex: 2;
    gap: 10px;

    @media (max-width: 720px) {
      flex-direction: row;
      width: 100%;
      margin-top: 10px;
    }
  }

  span {
    flex: 1;
    min-width: 500px;
    font-size: 16px;

    @media (max-width: 1080px) {
      min-width: 250px;
    }

    @media (max-width: 720px) {
      min-width: auto;
      width: 100%;
    }
  }

  input {
    flex: 2;
    width: 100%;
    padding: 12px;
    font-size: 16px;
    border: 1px solid ${({ theme }) => theme.colors.inputBorder};
    border-radius: 6px;
    outline: none;
    color: ${({ theme }) => theme.colors.textPrimary};
    background: ${({ theme }) => theme.colors.inputBackground};
    transition: border-color 0.3s;

    @media (max-width: 720px) {
      margin-top: 10px;
    }

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    -moz-appearance: textfield;

    &:focus {
      border-color: ${({ theme }) => theme.colors.primary};
    }
  }
`
